import React, { useEffect, useState } from "react"
import { View, TouchableOpacity } from "react-native"
import { Small } from "@/components/standard/BFText"
import PlaceIcon from "@/assets/icons/place.svg"
import { useRedfinAutocomplete } from "@/queries/markettrends"

interface ZipCodeSelectorProps {
  input: string // Current input value
  onSelect: (zipCode: string) => void // Callback when a ZIP code is selected
  onSuggestionsUpdate?: (suggestions: string[]) => void // Pass suggestions up
}

const MAX_SUGGESTIONS = 3

const ZipCodeSelector: React.FC<ZipCodeSelectorProps> = ({
  input,
  onSelect,
  onSuggestionsUpdate,
}) => {
  const [filteredSuggestions, setFilteredSuggestions] = useState<string[]>([])
  const { data: suggestions } = useRedfinAutocomplete(input)

  useEffect(() => {
    if (suggestions) {
      const newSuggestions = suggestions
        .map((item) => item?.region)
        .filter((region): region is string => !!region)
        .slice(0, MAX_SUGGESTIONS) // Limit suggestions to 3
      setFilteredSuggestions(newSuggestions)
      onSuggestionsUpdate?.(newSuggestions) // Pass suggestions to parent
    } else {
      setFilteredSuggestions([])
      onSuggestionsUpdate?.([]) // Pass empty suggestions
    }
  }, [suggestions, input, onSuggestionsUpdate])

  return (
    <>
      {/* Suggestions Dropdown */}
      {filteredSuggestions.length > 0 && (
        <View className="mt-1">
          {filteredSuggestions.map((item) => (
            <TouchableOpacity
              key={item}
              testID={`zipcode-${item}`}
              onPress={() => {
                onSelect(item)
              }}
              className="flex-row items-center gap-2 p-5 border-b border-light-grey"
            >
              <PlaceIcon />
              <Small className="text-midnight-blue">{item}</Small>
            </TouchableOpacity>
          ))}
        </View>
      )}
    </>
  )
}

export default ZipCodeSelector
